import React from "react";
import { Navigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import AdminDashboard from "./types/AdminDashboard";
import PartnerDashboard from "./types/PartnerDashboard";
import CustomerDashboard from "./types/CustomerDashboard";
import ServicePartnerDashboard from "./types/ServicePartnerDashboard";
import DefaultDashboard from "./types/DefaultDashboard";

/**
 * Maps customer_type (and optionally other conditions) to dashboard components.
 * Admin (type 1) lands on the dedicated Admin Dashboard at /admin/dashboard.
 */
const DASHBOARD_MAP = {
  1: null,
  2: PartnerDashboard,
  3: CustomerDashboard,
  7: ServicePartnerDashboard,
};

const DashboardResolver = () => {
  const { getAuthUser } = useJumboAuth();
  const authData = getAuthUser() || {};
  const customer = authData?.customer;

  const customerType =
    customer?.customerType ?? customer?.customer_type ?? null;

  if (Number(customerType) === 1) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const Component = DASHBOARD_MAP[customerType] || DefaultDashboard;
  return <Component />;
};

export default DashboardResolver;
